class KlevuInstantSearchInput extends HHBaseElement {
  constructor() {
    super();
    this.$input = this.querySelector('input');
    this.$instantSearchPopup = document.querySelector(
      'klevu-instant-search-popup'
    );
    this._handleQueryChange = this._handleQueryChange.bind(this);
  }

  connectedCallback() {
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    this.$input.addEventListener('keyup', this._handleQueryChange)
    this.$input.addEventListener('focus', this._handleQueryChange)
    this.$input.addEventListener('change', this._handleQueryChange)
  }

  _removeListeners() {
    this.$input.removeEventListener('keyup', this._handleQueryChange)
    this.$input.removeEventListener('focus', this._handleQueryChange)
    this.$input.removeEventListener('change', this._handleQueryChange)
  }

  _handleQueryChange(event) {
    const inputChangedEvent = new CustomEvent('instant-search-input::change', {
      detail: {
        value: this.$input.value,
        event: event
      },
      bubbles: true,
      composed: true
    });
    const openPanelEvent = new CustomEvent(
      'instant-search-popup::open',
      {
        bubbles: true,
        composed: true
      }
    );
    if (this.$instantSearchPopup) {
      this.$instantSearchPopup.dispatchEvent(inputChangedEvent);
      this.$instantSearchPopup.dispatchEvent(openPanelEvent);
    }
  }
}

window.customElements.define(
  'klevu-instant-search-input',
  KlevuInstantSearchInput
)
